import React, { memo } from "react";
import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import AxiosClient from "../../../client/AxiosClient";
import Loader from "../../../component/Loader";
import RawHTML from "../../../component/RawHTML";
import { API_GET_META_DATA } from "../../../ApiEndPoints";
import { useEffect } from "react";
import NativeLazyImage from "../../../component/NativeLazyImage";
import ReviewCard from "../../../component/ReviewCard";
import { FilledPrimaryBtn } from "../../../component/FilledBtn";
import WriteReviewModel from "./WriteReviewModel";

function WatchCourseAdditionalDetails({ course_id }) {
  const [key, setKey] = useState("reviews");

  const [showReviews, setShowReviews] = useState(false);

  // overview starts

  const [overviewLoading, setOverviewLoading] = useState(true);
  const [overviewData, setOverviewData] = useState(null);

  const [showReviewModal, setShowReviewModal] = useState(false);

  useEffect(() => {
    AxiosClient.post(API_GET_META_DATA, {
      course_id: course_id,
      type: "overview",
    })
      .then((response) => {
        const data = response.data;
        if (data.success == true) {
          setOverviewData(data.data);
          setOverviewLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error while fetching overview: ", err);
      });
  }, []);

  // overview ends

  // instructor starts

  const [instructorLoading, setinstructorLoading] = useState(true);
  const [instructorData, setInstructorData] = useState(null);

  useEffect(() => {
    AxiosClient.post(API_GET_META_DATA, {
      type: "instructor",
      course_id: course_id,
    })
      .then((response) => {
        const data = response.data;
        if (data.success == true) {
          setInstructorData(data.data);
          setinstructorLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error while fetching overview: ", err);
      });
  }, []);

  // instrucor ends

  // files starts

  const [filesLoading, setFilesLoading] = useState(true);
  const [filesData, setFilesData] = useState([]);

  useEffect(() => {
    AxiosClient.post(API_GET_META_DATA, {
      type: "additional_attachments",
      course_id: course_id,
    })
      .then((response) => {
        const data = response.data;
        if (data.success == true) {
          setFilesData(data.data);
          setFilesLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error while fetching additional files: ", err);
      });
  }, []);

  // files ends

  // reviews starts

  const [reviewsLoading, setReviewsLoading] = useState(true);
  const [reviewsData, setReviewsData] = useState([]);

  const [reloadReview, setReloadReview] = useState(0);

  function triggerReloadReview() {
    setReloadReview(reloadReview + 1);
  }

  useEffect(() => {
    AxiosClient.post(API_GET_META_DATA, {
      type: "reviews",
      course_id: course_id,
    })
      .then((response) => {
        const data = response.data;
        if (data.success == true) {
          setReviewsData(data.data);
          setReviewsLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error while fetching reviews: ", err);
      });
  }, [reloadReview]);

  // reviews ends

  return (
    <div className="watch-course-additional-details fw-500 mt-5">
      <Tabs id="" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
        <Tab eventKey="reviews" title="Reviews">
          {reviewsLoading && (
            <div className="my-2 text-center">
              <Loader />
            </div>
          )}
          {!reviewsLoading && reviewsData.length == 0 && (
            <p>No reviews found! Be the first to write one</p>
          )}

          <div className="d-flex justify-content-end my-2">
            <FilledPrimaryBtn
              clickHandler={() => {
                setShowReviewModal(true);
              }}
              label={`Write a review`}
            />
          </div>

          {!reviewsLoading &&
            reviewsData.map((item, index) => {
              if (showReviews == false && index > 2) {
                return null;
              }

              return (
                <ReviewCard
                  key={`review-${index}`}
                  avatar={item.user.image}
                  rating={item.star}
                  name={item.user.name}
                  review={item.comment}
                />
              );
            })}

          {reviewsData.length > 2 && (
            <FilledPrimaryBtn
              classes={"mx-auto"}
              clickHandler={() => {
                setShowReviews(!showReviews);
              }}
              label={showReviews ? "Show less" : "Show more"}
              type="button"
            />
          )}
        </Tab>
      </Tabs>

      <WriteReviewModel
        show={showReviewModal}
        course_id={course_id}
        triggerReloadReview={triggerReloadReview}
        onHide={() => {
          setShowReviewModal(false);
        }}
      />
    </div>
  );
}

export default memo(WatchCourseAdditionalDetails);
